import React, {useState, useEffect} from 'react';
import download from '../images/download.png';
import play from '../images/play(1).png';
import pause from '../images/pause(1).png';
import audioFile from '../images/song.mp3';
import rabii from '../images/sparsh_image.jpg';
import ReactTypingEffect from 'react-typing-effect';
import Temperature from '../components/Temperature';
import akhawayn from '../images/akhawayn.jpg';
import aesthe from '../images/aesthe.jpg';
import meInParis from '../images/me-in-paris.jpg';
import ups from '../images/ups.jpg';
import entreprise from '../images/enterprise.jpg';
import Orange from '../images/Orange.png';
import linkopus from '../images/linkopus_consulting_logo.jpg';
import Sqli from '../images/sqli.jpg';
import Map from '../images/map.jpg';
import github from '../images/github.png';
import resize from '../images/resize.png';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

const resume = "https://drive.google.com/drive/folders/1lhR9vXQ-mCEwSA9dOcNsaaSkYyxO8-MV?usp=sharing";

const About = () => {
    const [customCursorEnabled, setCustomCursorEnabled] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [audio] = useState(new Audio(audioFile));
    const [selectedCertificate, setSelectedCertificate] = useState(null);

    const certificates = [
      "https://i.imgur.com/ygshT5z.png",
      "https://i.imgur.com/PAn1onS.png",
      "https://i.imgur.com/z7PLKGR.png",
      "https://i.imgur.com/z7PLKGR.png",
      "https://i.imgur.com/UUBLSJy.png",
      entreprise
    ];

    const openCertificate = (certSrc) => {
      setSelectedCertificate(certSrc);
      document.body.style.overflow = 'hidden';
    };

    const closeCertificate = () => {
      setSelectedCertificate(null);
      document.body.style.overflow = 'visible';
    };

    useEffect(() => {
      if (selectedCertificate) {
        const handleEscape = (e) => {
          if (e.key === 'Escape') {
            closeCertificate();
          }
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
      }
    }, [selectedCertificate]);

    useEffect(() => {
        if (isPlaying) {
        audio.play();
        } else {
        audio.pause();
        }
    }, [isPlaying, audio]);

    const togglePlayPause = () => {
        setIsPlaying(!isPlaying);
    };

    return (
        
    <div>
        <>
        <div className='mt-40 min-h-screen flex flex-col justify-center items-center mx-9 lg:mx-32 md:mx-20 sm:mx-10'>
        <ScrollAnimation animateIn="fadeIn" animateOnce>
        <section className='mx-auto'>
            <div className="max-w-5xl">
                <h1 className="text-5xl font-bold text-center mx-24 mb-20 text-black-500">
                    {'// who'}
                <ReactTypingEffect
                    text={["ami?"]}
                    speed={150}
                    eraseDelay={3000}
                    typingDelay={1000}
                    cursor="_"
                />
                </h1>
            </div>
        </section>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeIn" animateOnce>
        <section className='flex flex-col items-center mx-auto'>
            <div className="flex flex-col lg:flex-row">
                <div className="w-full lg:w-1/2 mb-9 justify-center">
                    <ScrollAnimation animateIn="fadeIn" animateOnce>
                    <img className="object-cover h-full rounded-t-full w-3/4 lg:w-3/5 mx-auto xl:ml-32" src={rabii} alt="description" loading="eager" fetchPriority="high" decoding="async" style={{height:'70vh'}}/>
                    </ScrollAnimation>
                    <button className="w-3/4 lg:w-3/5 flex items-center text-green-200 px-4 py-4 bg-black bg-opacity-100 mx-auto xl:ml-32" onClick={togglePlayPause}>
                    <img src={isPlaying ? pause : play} className="h-12 w-12 fill-current text-white-200" alt={isPlaying ? "Pause Icon" : "Play Icon"} />
                    <span className="text-left ml-4">
                        <span className="block font-normal">Latest Musical Obsession</span>
                        <span className="block font-bold pr-3">Where Is the Love - The Monzas</span>
                    </span>
                    </button>
                </div>
                <div className="w-full lg:w-1/2 flex flex-col justify-center">
                    <h3 className="text-2xl font-bold mb-9 xl:mr-24 text-justify">
                      Hey<span style={{fontSize:'1.3em'}}> 👋</span>, I'm Rabii, a Product Engineer specializing in Human-Computer Interaction based in <Temperature /> <span className="text-3xl font-bold">🇫🇷</span> Paris, France.
                    </h3>
                    <p className='mb-6 xl:mr-24 text-justify'>
                    Skilled in product development, interaction design, user research, and frontend engineering. I've led product initiatives for multiple client platforms and collaborated with multidisciplinary teams to bring digital products from concept to launch.
                    </p>
                    <p className='mb-3 xl:mr-24 text-justify font-semibold'>Some of my hobbies include:</p>
                    <div className='mb-6 xl:mr-24 flex flex-wrap gap-3 justify-start'>
                      <span className='text-4xl md:text-5xl'>⚽</span>
                      <span className='text-4xl md:text-5xl'>🏓</span>
                      <span className='text-4xl md:text-5xl'>🎥</span>
                      <span className='text-4xl md:text-5xl'>🎹</span>
                      <span className='text-4xl md:text-5xl'>🎨</span>
                      <span className='text-4xl md:text-5xl'>📚</span>
                    </div>
                    <div className='lg:mt-4'>
                        <a href={resume} target='_blank' rel='noopener noreferrer'>
                            <button className="hover:brightness-0 border-2 border-black flex items-center text-white hover:text-black px-4 py-3 rounded-full bg-black hover:bg-transparent transition duration-300">
                              <img src={download} className=' w-4 text-black-200' alt='download-resume' />
                                <span className="text-left ml-4">
                                    <span className="block font-semibold pr-3">Resume.CV</span>
                                </span>
                            </button>
                        </a>
                    </div>
                </div>
                </div>
        </section>
        </ScrollAnimation>

        {/* Company Logos - Static */}
        <ScrollAnimation animateIn="fadeIn" animateOnce>
        <div className="w-full pt-20 pb-16">
          <h2 className='text-4xl font-bold mb-12 text-center mx-6'>Companies I've Worked With</h2>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-16 px-6">
            {[
              Sqli, 
              Map, 
              Orange,
              linkopus,
              "https://i.imgur.com/et5vncL.png",
              "https://i.imgur.com/1MHsHkB.png"
            ].map((logo, idx) => (
              <div key={idx} className="flex items-center justify-center">
                <img 
                  src={logo} 
                  alt="Company Logo" 
                  loading="lazy"
                  decoding="async"
                  className="h-16 md:h-24 object-contain border border-black"
                />
              </div>
            ))}
          </div>
        </div>
        </ScrollAnimation>

        {/* Education Section */}
        <ScrollAnimation animateIn="fadeIn" animateOnce>
        <section>
            <div className='mt-14 justify-center items-center lg:w-1/2 flex flex-col mx-auto w-full'>
                <h2 className='text-4xl font-bold mb-8 text-center'>Education</h2>
                <p className='mb-6 text-justify'>I graduated from Al Akhawayn University in Dec 2023 with a Bachelor of Science in Computer Science and a minor in Business Administration. In my college years, I was honored to be included on the Dean's List six times, and graduated with honors getting a Summa Cum Laude.</p>
                <div className='mb-6 inline-block'>
                  <div className='inline-block px-6 py-3 bg-black text-white rounded-full font-bold text-lg'>
                    CGPA: 3.7/4.0
                  </div>
                </div>
            </div>
        </section>
        <section className='mt-20'>
            <div class="grid lg:grid-cols-2 grid-cols-1 gap-4 w-full mx-auto">
                <div class="flex justify-center items-center mx-auto">
                    <img src={akhawayn} class="object-cover rounded-lg" alt="Akhawayn" loading="lazy" decoding="async" style={{borderRadius:'2em', height:'100vh', width:'auto'}}/>
                </div>
                <div class="flex justify-center items-center mx-auto">
                    <img src={aesthe} class="object-cover rounded-lg" alt="Aesthe" loading="lazy" decoding="async" style={{borderRadius:'2em',height:'100vh', width:'auto'}}/>
                </div>
            </div>
        </section>
        <section className='mt-14'>
            <div className='justify-center items-center lg:w-1/2 flex flex-col mx-auto w-full'>
                <p className='mb-6 text-justify'>Currently, I am pursuing my Master's degree in Human Computer Interaction at Université Paris-Saclay, one of France's most prestigious universities, known for its excellence in research and innovation.</p>
                <div className='mb-6 inline-block'>
                  <div className='inline-block px-6 py-3 bg-black text-white rounded-full font-bold text-lg'>
                    CGPA: 16/20
                  </div>
                </div>
            </div>
        </section>
        <section className='mt-20'>
            <div class="grid lg:grid-cols-2 grid-cols-1 gap-4 w-full mx-auto">
                <div class="flex justify-center items-center mx-auto">
                    <img src={ups} class="object-cover rounded-lg" alt="UPS" loading="lazy" decoding="async" style={{borderRadius:'2em', height:'100vh', width:'auto'}}/>
                </div>
                <div class="flex justify-center items-center mx-auto">
                    <img src={meInParis} class="object-cover rounded-lg" alt="Me in Paris" loading="lazy" decoding="async" style={{borderRadius:'2em',height:'100vh', width:'auto'}}/>
                </div>
            </div>
        </section>
        </ScrollAnimation>

        {/* Certificates Section - Grid Layout */}
        <ScrollAnimation animateIn="fadeIn" animateOnce>
        <div className="w-full pt-20 pb-16">
        <div className='mx-6 2xl:mx-60'>
          <h2 className='text-4xl font-bold mb-12 text-center'>Certificates</h2>
          <div className='grid grid-cols-2 md:grid-cols-3 gap-6 mb-8'>
            {certificates.map((cert, index) => (
              <div 
                key={index} 
                className='cursor-pointer transform hover:scale-105 transition-transform duration-300 relative'
                onClick={() => openCertificate(cert)}
              >
                <img
                  src={cert}
                  loading='lazy'
                  decoding="async"
                  alt={`Certificate ${index + 1}`}
                  className="w-full h-auto object-contain shadow-md hover:shadow-xl transition-shadow"
                />
                <div className="absolute top-2 right-2 bg-black bg-opacity-70 rounded-full p-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                  </svg>
                </div>
              </div>
            ))}
          </div>
          <div className='flex justify-center mt-8'>
            <a 
              className='cursor-pointer inline-block' 
              href="https://drive.google.com/drive/folders/1FsFNw_8ivl9oSV_kbrO7Zm8hYMUDh3bF?usp=sharing" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <div className='rounded-full bg-black px-8 py-4 text-center hover:bg-gray-800 transition duration-300'>
                <h2 className='text-lg font-semibold text-white'>More Certificates</h2>
              </div>
            </a>
          </div>
        </div>
        </div>
        </ScrollAnimation>
        
        {/* Certificate Modal */}
        {selectedCertificate && (
          <div 
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4"
            onClick={closeCertificate}
          >
            <button 
              className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 z-50"
              onClick={closeCertificate}
            >
              ×
            </button>
            <img 
              src={selectedCertificate} 
              alt="Certificate Full Size" 
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
              loading="eager"
              decoding="async"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
        </div>
        </>
    </div>
  );
};

export default About;

